module.exports = __webpack_public_path__ + "assets/pdf/E17-cn-extreme-cold.1d5d569e.pdf";